export default {
  // アンカー船IDの配列を取得する
  getAnchorVesselIds: (state, _getters, _rootState, rootGetters) => {
    const addonFlag = rootGetters.getAddonFlag("GKMG_ANCHOR_MANAGEMENT");
    // addonがfalseの場合空配列を返す
    if (!addonFlag) return [];
    return state.anchors.map((a) => a.vessel_id);
  },
};
